import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/Home.css';

function Home() {

    const navigate = useNavigate();

    const [alertVisible, setAlertVisible] = useState(false)

    const navigateToRandomPage = () => {
        const pages = ['/fizzbuzz', '/firstnonrepeatingchar', '/fixgroup', '/longestincresingstring'];
        const randomPage = pages[Math.floor(Math.random() * pages.length)];
        navigate(randomPage);
    };

    const handleClick = () => {
        localStorage.clear()
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 2000)
    }

    return (
        <>
            <h2>
                Wilkommen auf der Mini-Challenges Seite der C3
            </h2>


            <div className="app-container">
                <p>Hier findest du verschiedene Mini-Challenges, welche du bearbeiten kannst. Dabei gibt es Challenges, welche du komplett lösen sollst, und Fehlerhafte Challenges, welche du korrigieren kannst</p>

                <p>Wähle eine Challenge:</p>
                <div className="home-challenge-container">
                    <div>
                        <button className="challenge-button" onClick={() => navigate('/fizzbuzz')}>FizzBuzz</button>
                        <p>Zahlen von 1-100 ausgeben und dabei jede 3. und 5. Zahl ersetzen</p>
                    </div>
                    <p></p>
                    <div>
                        <button className="challenge-button"
                                onClick={() => navigate('/firstnonrepeatingchar')}>FirstNonRepeatingChar
                        </button>
                        <p>Ersten sich nicht wiederholenden Buchstaben zurückgeben</p>
                    </div>
                    <p></p>
                    <div>
                        <button className="challenge-button" onClick={() => navigate('/fixgroup')}>FixGrouping</button>
                        <p>Personen nach zugehörigen Gruppen sortieren</p>

                    </div>
                    <p></p>
                    <div>
                        <button className="challenge-button"
                                onClick={() => navigate('/longestincresingstring')}>LongestIncreasingString
                        </button>
                        <p>Längste Aufsteigende Teilfolge eines Arrays zurückgeben</p>
                    </div>
                    <p></p>
                    <div>
                        <button className="challenge-button" onClick={() => navigate('/palindrome')}>Palindrome</button>
                        <p>Bei einem String soll geprüft werden, ob es sic um ein Palindrom handelt</p>
                    </div>
                    <p></p>
                    <div>
                        <button className="challenge-button" onClick={() => navigate('/duplicates')}>RemoveDuplicates
                        </button>
                        <p>Duplikate aus einem Array entfernen</p>
                    </div>
                    <p></p>
                    <div>
                        <button className="challenge-button" onClick={() => navigate('/zweierpotenz')}>Zweier Potenz
                        </button>
                        <p>Überprüfen ob es sich bei Zahl um zweier Potenz handelt</p>
                    </div>
                    <p></p>
                    <div>
                        <button className="challenge-button" onClick={() => navigate('/movezeros')}>Nullen verschieben
                        </button>
                        <p>Nullen in einem Array ans ende verschieben</p>
                    </div>

                    <div className="random-button-container">
                        <button className="random-button" onClick={navigateToRandomPage}>Go to Random Page</button>
                        <p>Hier geht es zu einer zufälligen Challenge:</p>
                    </div>

                    <div>
                        <button className="reset-button" onClick={handleClick}>
                            Code zurücksetzen
                        </button>
                        <div className={`alert ${alertVisible ? 'active' : ''}`}>
                            Code wurde gelöscht!
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
